import { BOOLEAN_SELECT_LIST_ITEMS, Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  StudentServiceTypeFilter as StudentServiceTypeFilterModel,
  StudentServiceTypeFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentServiceTypeFilter = (props: {
  filter: StudentServiceTypeFilterModel;
  setFilter: (value: StudentServiceTypeFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentServiceTypeFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.studentServiceTypes.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolField = () => {
    const propertyName = pn<StudentServiceTypeFilterModel>("schoolId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.schools?.find((x) => x.id === props.filter.schoolId)}
        options={resource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolId = value?.id;
            })
          )
        }
      />
    );
  };

  const inactiveField = () => {
    const propertyName = pn<StudentServiceTypeFilterModel>("inactive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS?.find((x) => x.id === props.filter.inactive)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.inactive = value?.id;
            })
          )
        }
      />
    );
  };

  const isForParentField = () => {
    const propertyName = pn<StudentServiceTypeFilterModel>("isForParent");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS?.find((x) => x.id === props.filter.isForParent)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.isForParent = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {schoolField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {isForParentField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {inactiveField()}
      </Grid>
    </Grid>
  );
};
